import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { apiFetch } from '@/api/client'
import { useSessionStore } from '@/store/sessionStore'

export function LogoutButton() {
  const { t } = useTranslation()
  const [confirming, setConfirming] = useState(false)
  const { token, clearSession } = useSessionStore()
  const navigate = useNavigate()

  async function handleLogout() {
    if (!confirming) { setConfirming(true); return }
    try {
      if (token) await apiFetch('/session/logout', { method: 'POST', token })
    } finally {
      clearSession()
      navigate('/join', { replace: true })
    }
  }

  if (confirming) {
    return (
      <div className="flex items-center gap-1">
        <span className="text-xs text-white/50">{t('nav.signOutConfirm')}</span>
        <button onClick={handleLogout} className="text-xs text-red-400 hover:text-red-300 font-semibold transition-colors px-1.5 py-0.5 rounded hover:bg-red-500/10">{t('nav.yes')}</button>
        <button onClick={() => setConfirming(false)} className="text-xs text-white/40 hover:text-white/70 transition-colors px-1.5 py-0.5 rounded hover:bg-white/5">{t('nav.no')}</button>
      </div>
    )
  }

  return (
    <button onClick={handleLogout}
      className="text-xs text-white/30 hover:text-white/60 transition-colors px-1.5 py-0.5 rounded hover:bg-white/5"
      title={t('nav.signOut')}>
      {t('nav.signOut')}
    </button>
  )
}
